module.exports = __webpack_public_path__ + "components/flag/static/square/ge-3e4bb9a49583981c8617382d0cbed7cc.svg";